/**
 * BrandHeader — Lyoko Tech wordmark at top of public payment pages.
 * Text-only for v1; no logo asset needed.
 */

export function BrandHeader() {
  return (
    <header className="text-center mb-8">
      <div className="inline-flex items-center gap-2">
        <div className="h-8 w-8 rounded-lg bg-primary-600 flex items-center justify-center">
          <span className="text-white font-bold text-sm" aria-hidden="true">
            L
          </span>
        </div>
        <span className="text-xl font-bold text-gray-900 dark:text-gray-100 tracking-tight">Lyoko Tech</span>
      </div>
    </header>
  );
}
